// $(function() {
//   const form = $(".contact-form");
//   const submitBtm = form.find(".submit-btn");
//   form.on("submit", function(e) {
//     form.find(".alert").remove();
//     submitBtm.attr("disabled", "disabled");
//     const nameField = form.find('input[name="name"]');
//     const emailField = form.find('input[name="email"]');
//     const messageField = form.find('textarea[name="message"]');
//     const data = {
//       name: nameField.val(),
//       email: emailField.val(),
//       message: messageField.val()
//     };
//     const url = window.API_URL + "/form";
import $ from 'jquery'

//     $.post(url, data)
//       .done(function(res) {
//         const message = res.message;
//         const okEl = '<div class="alert ok"><p>' + message + "</p></div>";
//         form.prepend(okEl);
//         nameField.val("");
//         emailField.val("");
//         messageField.val("");
//         submitBtm.removeAttr("disabled");
//       })
//       .catch(function(err) {
//         if (err.status === 422) {
//           let errors = [];
//           err.responseJSON.errors.map(error => {
//             errors.push(error.message);
//           });
//           const content = errors.map(error => "<p>" + error + "</p>").join("");
//           var errorsEl = $('<div class="alert errors">' + content + "</div>");
//           form.prepend(errorsEl);
//           submitBtm.removeAttr("disabled");
//         }
//       });
//     return false;
//   });

// });

// menu

export const setupMenu = () => {
  const breakpoint = 991;
  const menu = $(".main-menu");
  const menuToogle = $(".main-menu-trigger");
  const openClass = "opened";

  const hideMenu = () => {
    menuToogle.removeClass(openClass);
    menu.slideUp();
  };
  const showMenu = () => {
    menuToogle.addClass(openClass);
    menu.slideDown();
  };

  const onResize = () => {
    if (window.innerWidth <= breakpoint) {
      hideMenu();
    } else {
      showMenu();
    }
  };

  menuToogle.find("a").on("click", function(e) {
    e.preventDefault();
    if (menuToogle.hasClass(openClass)) {
      hideMenu();
    } else {
      showMenu();
    }
  });

  $(window).on("resize", e => {
    // onResize();
  });
  // on load
  onResize();
};
